module.exports = __webpack_public_path__ + "assets/f24d2a4a7410d792f2a402cd272574f0.mp4";